import { useGoalsAndInterventionsWizard } from './GoalsAndInterventionsWizardContext';

export function Breadcrumbs() {
	const { wizardState } = useGoalsAndInterventionsWizard();
	if (wizardState.currentStep === 'SELECT_GOAL' || wizardState.currentStep === 'LOAD_GOAL_DEFINITION') {
		return <span className="text-sm text-primary-500">Select Goal</span>;
	} else if (wizardState.currentStep === 'CAPTURE_GOAL_DETAILS') {
		return (
			<div className="flex items-center">
				<span className="text-sm text-gray-500">Select Goal &gt;</span>
				<span className="text-sm text-primary-500">&nbsp;Goal Details</span>
			</div>
		);
	} else if (wizardState.currentStep === 'SELECTING_INTERVENTIONS') {
		const hasGoalDetails =
			wizardState.selectedGoal &&
			wizardState.selectedGoal.type !== 'existing' &&
			(wizardState.selectedGoal.type === 'custom' || wizardState.selectedGoal.goalDefinition.hasDefinitionFields);
		return (
			<div className="flex items-center">
				<span className="text-sm text-gray-500">Select Goal &gt;</span>
				{hasGoalDetails && <span className="text-sm text-gray-500">&nbsp;Goal Details &gt;</span>}

				<span className="text-sm text-primary-500">&nbsp;Select Interventions</span>
			</div>
		);
	}

	return null;
}
